<template>
    <main-site>
        <template #main_content>
            <inertia-head>
                <title>{{ content.title}}</title>
                <meta name="description" :content="`${textShorter(content.body,150)}`"/>
                <meta property="og:title" :content="`${content.title}`"/>
                <meta property="og:description" :content="`${textShorter(content.body,150)}`"/>
                <meta name="twitter:title" :content="`${content.title}`">
                <link rel="canonical" :href="canonicalLink"/>
            </inertia-head>

            <div class="container mx-auto pt-[30px] lg:pt-1 mb-3">
                <div class="text-center place-items-center mx-2 sm:mx-auto max-w-screen-xl">
                    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-2">
                        <div class="col-span-2">
                            <div class="rounded-2xl shadow-xl bg-white p-9 pt-9 border max-w-screen-xl">
                                <div class="my-3 page-header">
                                    <h2> {{ content.title }} </h2>
                                </div>
                                <p class="page-body" v-html="content.body"></p>

                                <form class="gap-2">
                                    <div class="text-left mt-5">
                                        <div class="flex items-center">
                                            <JetLabel for="title" value="Question" class="text-gray-600 mb-1" />
                                            <span class="text-[#3bb3bd] ml-1">- Required</span>
                                        </div>
                                        <JetInput 
                                            id="title" 
                                            placeholder="Write your question here..."
                                            class="placeholder-gray-300 border-dashed border block w-full outline-none p-2 focus:outline-none" 
                                            v-model="formData.title"
                                            ref="title"/>
                                        <JetInputError :message="validation['title']" class="mt-2" />
                                    </div>
                                    <div class="text-left mt-5">
                                        <div class="flex items-center">
                                            <JetLabel for="email" value="Email" class="text-gray-600 mb-1" />
                                            <span class="text-[#3bb3bd] ml-1">- Required</span>
                                        </div>
                                        <JetInput 
                                            id="email"
                                            placeholder="We’ll send our response to this email…"
                                            class="placeholder-gray-300 border-dashed border block w-full outline-none p-2 focus:outline-none"
                                            v-model="formData.email"
                                            ref="email"/>
                                        <JetInputError :message="validation['email']" class="mt-2" />
                                    </div>
                                    <div class="text-left mt-5">
                                        <div class="flex items-center">
                                            <JetLabel for="description" value="More details" class="text-gray-600 mb-1"/>
                                            <span class="text-gray-400 ml-1">- Optional</span>
                                        </div>
                                        <textarea 
                                            placeholder="Add anything else we need to know to give you a great answer…"
                                            v-model="formData.description"
                                            class="text-[13px] border-gray-300 placeholder-gray-300 border-dashed border rounded-lg w-full h-64 outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"></textarea>
                                        <JetInputError :message="validation['description']" class="mt-2" />
                                    </div>
                                </form>
                                <div class="flex justify-start mt-5 items-center gap-2">
                                    <button class="gold-btn outline-none" @click="postContactUs">
                                        Submit
                                    </button>
                                    <div v-if="successMessage">
                                        <span class="p-2 text-green-800 bg-green-200 rounded-lg">
                                            {{ successMessage }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="order-first md:order-last">
                            <div class="rounded-2xl shadow-xl bg-white p-9 pt-9 border max-w-screen-xl">
                                <li class="text-gray-600 text-md font-bold my-3 list-none">
                                    <div class="flex items-center mt-2">
                                        <span class="material-icons pr-2">email</span>
                                        <a href="mailto:support@happytrainers.com">
                                            support@happytrainers.com
                                        </a>
                                    </div>
                                </li>
                                <hr class="my-3 text-gray-700 col-span-9 w-full hidden sm:block">
                                <li class="text-gray-600 text-md font-bold my-3 list-none">
                                    <div class="text-left mt-2 flex items-center">
                                        <span class="material-icons pr-2">phone_in_talk</span>
                                        <a href="tel:16478777232">
                                            +1(647)877-7232
                                        </a>
                                    </div>
                                </li>
                                <hr class="my-3 text-gray-700 col-span-9 w-full hidden sm:block">
                                <li class="text-gray-600 text-md font-bold my-3 list-none">
                                    <div class="text-left flex items-start justify-center mt-2">
                                        <span class="material-icons pr-2">location_on</span>
                                        <address>
                                            Canada <br>
                                            300 Ray Lawson Blvd, Suite 407, Brampton, ON, L6Y 5H5
                                        </address>
                                    </div>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </main-site>

</template>

<script>
import MainSite from "@/Pages/Components/MainSite";
import {Link, InertiaHead} from '@inertiajs/inertia-vue3'
import myMixin from "@/myMixin";
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'

export default {
    name: "PageContent",
    components: {InertiaHead, Link, MainSite, JetLabel, JetInput, JetInputError, JetButton},
    mixins: [myMixin],
    props: {
        content: Object,
        canonicalLink: String,
    },
    data() {
        return {
            validation: {},
            successMessage: null,
            formData: this.$inertia.form({
                '_method': 'POST',
                title: null,
                email: null,
                description: null,
            }),
        }
    },
    methods:{
        postContactUs(){
            this.successMessage = null;
            this.validation = {};
            if(! this.formData.title || ! this.formData.email){
                if(! this.formData.title){
                    this.validation.title = 'This field is required.'
                };

                if(! this.formData.email){
                    this.validation.email = 'This field is required.';
                }
            }else{
                this.formData.post(route('post.contact-us'), {
                    onSuccess: (response) => {
                        this.successMessage = 'Message received. thank you! We’ll be in touch.';
                        setTimeout(() => {
                            this.successMessage = null;
                        }, 5000);
                        this.formData.title = null;
                        this.formData.description = null;
                        this.formData.email = null;
                    }
                });
            }
        }
    }
}
</script>

<style>
.page-header {
    font-family: SegoeUI;
    font-size: 5vmin;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #555454;
}

.page-body {
    margin: 16px 0 0;
    font-family: SegoeUI;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #555454;
}
</style>
